module.exports = __webpack_public_path__ + "static/media/auv_bg_sm.e50802dd.jpg";